module.exports = __webpack_public_path__ + "static/media/photoProfile.07ff1713.JPG";